export default __webpack_public_path__ + "static/media/doctors-house.64211a5c.jpg";